<template>
	<div class="change-password">
		<GuestLayout class="box">
			<form @submit.prevent="changePassword()" slot="guest-body" class="guest-body">

				<span class="info-desc">
					Input your new password to change.
				</span>

				<InputField
					class="input-line"
					label="New Password"
					placeholder="New Password"
					:togglePassword="true"
					type="password"
					v-model="newPassword"
				/>

				<InputField
					class="input-line"
					v-model="confirmPassword"
					label="Confirm Password"
					placeholder="Confirm Password"
					type="password"
					:togglePassword="true"
				/>

				<!-- <div class="error-container" v-if="error && typeof error === 'object'">
					<span v-for="(error, key) in error.password" :key="key">{{ error | capitalize }}</span>
				</div> -->

				<!-- <div class="error-container" v-if="linkExpirationMessage">
					<span>
						{{ linkExpirationMessage | capitalize }}
					</span>
				</div> -->

				<div class="controls">
					<button class="_primary" type="submit" :disabled="loading">
						{{ loading ? 'Loading...' : 'Change Password' }}
					</button>
				</div>
			</form>
		</GuestLayout>
	</div>
</template>
<script>
import { mapFields } from 'vuex-map-fields'
import GuestLayout from '@/components/layouts/GuestLayout'
import InputField from '@/components/utils/InputField.vue'

export default {
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (!vm.$route.params.token) {
				next({ name: 'sign-in' })
			} else {
				next()
			}
		})
	},

	activated () {
		this.$store.commit('auth/clearAuth')
		this.checkLinkExpiration()
	},

	components: {
		InputField,
		GuestLayout
	},

	computed: {
		...mapFields('auth', [
			'newPassword',
			'confirmPassword',
			''
        ]),
	},

	methods: {
		checkLinkExpiration () {
			let form = new FormData()

			form.append('token', this.$route.params.token)
			this.$store.dispatch('checkLinkExpiration', form)
		},

		changePassword () {
			let form = new FormData()

			form.append('token', this.$route.params.token)
			form.append('password', this.newPassword)
			form.append('password_confirmation', this.confirmPassword)
			this.$store.dispatch('changePassword', form)
		}
	}
}
</script>
<style lang="scss" scoped>
.change-password {
	width: 100%;
	height: 100%;

	.guest-body {
		span {
			display: block;
		}

		.info-desc {
			color: #575B5C;
			font-size: 16px;
			text-align: center;
			margin-bottom: 40px;
		}

		.input-line {
			margin-bottom: 40px;

			&:nth-child(3) {
				margin-bottom: 10px;
			}
		}

		.controls {
			display: flex;
			flex-direction: column;
			align-items: center;

			button {
				margin: 35px 0 25px 0;
				width: 150px;
			}
		}
	}

	.error-container {
		span {
			color: #E71D36;
			margin-bottom: 7px;
		}
	}
}
</style>
